import classNames from 'classnames';

// styles
import s from './Grid.sss';

type CountType = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | '2_4';
type SpacingType = 0 | 10;

export type GridProps = {
  container?: boolean;
  spacing?: SpacingType;
  desktop?: CountType;
  tablet?: CountType
  def?: CountType;
  className?: string;
};

export const Grid: React.FC<React.PropsWithChildren<GridProps>> = ({
  children,
  desktop,
  tablet,
  def,
  container = false,
  spacing = 0,
  className,
}) => {
  if (container) {
    return (
      <div className={classNames(s[`spacing${spacing}`], className)}>
        <div className={s.innerContainer}>
          {children}
        </div>
      </div>
    );
  }

  return (
    <div
      className={classNames(
        s.item,
        { [s[`desktop${desktop}`]]: !!desktop },
        { [s[`tablet${tablet}`]]: !!tablet },
        { [s[`default${def}`]]: !!def },
      )}
    >
      {children}
    </div>
  );
};

export default Grid;
